import styled from "styled-components";

const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-bottom: 15px;
`;

const FilterSearchStyle = styled.input`
  width: 300px;
  height: 38px;
  padding-left: 30px;
  background: var(--color-workspace-bg-page-area);
  border: 1px solid var(--color-table-border-pageinput);
  border-radius: 3px;
  font-size: 14px;

  &:focus-visible {
    outline-color: #EC407A;
  }
`;

const IconWrapper = styled.span`
  position: absolute;
  left: 8px;
  display: flex;
  align-items: center;
  pointer-events: none;
`;

const FilterSearch = (props) => {
    const setSearch = props.setSearch;
    return (
        <Wrapper>
            <IconWrapper>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.8886 11.3869L8.97625 8.47368C9.84596 7.47277 10.2932 6.17321 10.2238 4.84889C10.1543 3.52456 9.57361 2.27893 8.60399 1.37454C7.63437 0.470138 6.3516 -0.0223827 5.02605 0.000781577C3.7005 0.0239459 2.43572 0.560985 1.49827 1.49871C0.56082 2.43643 0.0239388 3.70159 0.000781346 5.02753C-0.0223761 6.35348 0.469999 7.63662 1.37413 8.60653C2.27826 9.57643 3.52352 10.1573 4.84746 10.2268C6.17139 10.2963 7.47057 9.84887 8.47118 8.9789L11.3847 11.8933C11.4514 11.9606 11.5419 11.9989 11.6367 12C11.6837 12.0001 11.7302 11.9907 11.7735 11.9723C11.8168 11.954 11.856 11.9271 11.8886 11.8933C11.9553 11.8259 11.9927 11.7349 11.9927 11.6401C11.9927 11.5453 11.9553 11.4543 11.8886 11.3869ZM0.722597 5.11652C0.723944 4.24759 0.982765 3.39857 1.46635 2.67673C1.94994 1.9549 2.63659 1.39266 3.43952 1.06107C4.24246 0.729482 5.12564 0.64342 5.97745 0.813765C6.82927 0.984109 7.61149 1.40321 8.22526 2.01811C8.83902 2.63302 9.25679 3.41611 9.42577 4.26844C9.59474 5.12077 9.50734 6.00408 9.1746 6.80674C8.84187 7.60939 8.27873 8.29537 7.55636 8.77798C6.834 9.26059 5.98482 9.51818 5.11615 9.51818C3.9501 9.51697 2.83225 9.05263 2.00836 8.22722C1.18447 7.40181 0.721995 6.28292 0.722597 5.11652Z" fill="#666666"/>
                </svg>
            </IconWrapper>
            <FilterSearchStyle
                type="text"
                id="filter_blueprint"
                placeholder="Search BluePrint..."
                onChange={(event) => { setSearch(event.target.value); }}
            />
        </Wrapper>
    );
};

export default FilterSearch;
